const VENUE_PAGE_BASE = "/venue/:venueId";
const STAGE_PAGE_BASE = `${VENUE_PAGE_BASE}/stage/:stageId`;
export const STAGE_PAGE_BASE_MATCH = `${STAGE_PAGE_BASE}([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})`;

export const VENUE_PATHS = {
  CREATE_VENUE: "/venues/create",
  VENUE: `${VENUE_PAGE_BASE}`,
  VENUE_PAGE_ROUTER: `${VENUE_PAGE_BASE}/:path?/:stageId?`,
  EDIT_VENUE: `${VENUE_PAGE_BASE}/edit`,
  EDIT_VENUE_BRANDING: `${VENUE_PAGE_BASE}/edit/branding`,
  EDIT_VENUE_EQUIPMENT: `${VENUE_PAGE_BASE}/edit/equipment`,
  EDIT_VENUE_INFO_BLOCK: `${VENUE_PAGE_BASE}/edit/:infoBlockSlug`,
  CREATE_VENUE_STAGE: `${VENUE_PAGE_BASE}/stage/create`,
  STAGE_PAGE_ROUTER: `${STAGE_PAGE_BASE}`,
  STAGE: `${STAGE_PAGE_BASE}`,
  EDIT_STAGE: `${STAGE_PAGE_BASE}/edit`,
  EDIT_STAGE_EQUIPMENT: `${STAGE_PAGE_BASE}/edit/equipment/:categorySlug`,
  EDIT_STAGE_INFO_BLOCK: `${STAGE_PAGE_BASE}/edit/:infoBlockSlug`,
};
